import axios from 'axios'

class ApiService {
  constructor () {
    console.log('CONSTRUCT ApiService')
  }

  async loginCabine (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/users/login-cabine`
    const response = await axios.post(url, payload)
    return response.data
  }
  
  async createUser (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/users/create-user-cabine`
    const response = await axios.post(url, payload)
    return response.data
  }
  
  async saveLgpd (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/users/lgpd-confirm-cabine`
    const response = await axios.post(url, payload)
    return response.data
  }
  
  async forgetPassword (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/users/troca-senha-cabine`
    const response = await axios.post(url, payload)
    return response.data
  }
  
  async sendCodePassword (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/users/password-code-cabine`
    const response = await axios.post(url, payload)
    return response.data
  }
  
  async changePassword (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/users/change-password-cabine`
    const response = await axios.post(url, payload)
    return response.data
  }
  
  async resetNewPassword (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/user-patient/new-reset-patients`
    const response = await axios.post(url, payload)
    return response.data
  }

  async saveTeleconsultMovimentLog (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/teleconsult/save-log`;
    try {
      await axios.post(url, payload);
    } catch (err) {
      console.error('[saveTeleconsultMovimentLog]', err)
    }
  }
}

export default ApiService
